import { ILogProps } from './types';
import { api } from '../../DefaultService';
import { IPaginationParams } from '../../types';

export const LOG_ENDPOINT = 'v1/events/eventLog';

export const getAllLogsByDeviceAsync = async (
  id: number,
  pagination: IPaginationParams,
): Promise<ILogProps[]> => {
  return await api
    .get<ILogProps[]>(LOG_ENDPOINT + '/getAllByDevice/' + id, {
      params: { ...pagination },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllLogsCountByDeviceAsync = async (
  id: number,
): Promise<number> => {
  return await api
    .get(`${LOG_ENDPOINT}/getAllByDevice/${id}/count`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
